export default __webpack_public_path__ + "static/waiting-3986b087b8afbac979c0cdd148a1b818.png";